<template>
    <div id="complete2">
        <Header />
            <div class="complete2_box">
                <img src="../assets/images/img_finished_sign_up.svg" alt="가입 끝 이미지">
                <h1>회원가입을 축하합니다.<br>지금부터 Artube프리미엄 웹툰을 즐겨보세요</h1>
                <p><span>{{distance}}초 후</span>메인화면으로 이동합니다.</p>
                <router-link tag="div" to="/" class="button">확인</router-link>
            </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer
    },
    data(){
        return{
            timer: null,
            distance: 5,
        }
    },
    mounted(){
        this.timer = setInterval(this.showRemaining, 1000);
    },
    beforeDestroyI(){
        if(this.timer !== null){
            clearInterval(this.timer);
        }
    },
    methods:{
        showRemaining() {
            var that = this;
            if (this.distance <= 0) {
                clearInterval(that.timer);
                that.$router.push('/');
                return;
            }

            this.distance = this.distance - 1;
        }

    }
}
</script>